
const RagGuidelines = () => {
  return (
    <h1>Rag Guidelines</h1>
  )
}

export default RagGuidelines